import React from "react";
export var HeroBackground = function (_a) {
    var className = _a.className;
    return (React.createElement("svg", { viewBox: "0 0 428 241", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: className },
        React.createElement("rect", { y: "191", width: "345", height: "50", fill: "#006729" }),
        React.createElement("rect", { x: "381", width: "47", height: "116", fill: "#00A3A8" }),
        React.createElement("rect", { width: "383", height: "192", fill: "#65A518" })));
};
